//copy from src\components\ElectronicIllnessAttestation\fetchFile.js  
import { API_BASE_URL } from "../../constants/apiConstants";
import axios from "axios";

export const fetchFile = (client, program, accessToken, ffe3Key, fileName, userId) => {
    return new Promise((resolve, reject) => {
        const payload = {
            mandant: client,
            program: program,
            statement: "OEFFNE_DOKUMENT",
            dockey: ffe3Key,
            userId: userId
        };
        const headers = {
            Authorization: "Bearer " + accessToken,
        };
        axios.post(API_BASE_URL + 'daten', payload, { headers: headers, responseType: 'blob' })
            .then((response) => {
                if (response.status === 200) {
                    resolve({
                        name: fileName,
                        content: response.data,
                        type: response.headers['content-type'],

                    });
                } else {
                    if (response) {
                        reject(response.data.message);
                    } else {
                        reject("Keine Internetverbindung");
                    }
                }
                resolve();
            })
            .catch(() => reject("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."));
    });
}
